import React from 'react';

import { SelectLightRecipe } from '@ledium/ui-common';
import { Grid } from '@mui/material';

const SpectrumMixerSelectLightRecipe = () => (
    <Grid item xs={12}>
        <SelectLightRecipe />
    </Grid>
);

export default SpectrumMixerSelectLightRecipe;
